module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-465.b350393.woff2";